import { Tooltip, Typography } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { MRT_ColumnDef } from "material-react-table";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";



import { SysCfgRegularDto } from "@/shared/api";


export const useGameTypeTableColumns = () => {
  const { t } = useTranslation();

  return useMemo<MRT_ColumnDef<SysCfgRegularDto>[]>(
    () => [
      {
        header: t("enabled"),
        filterFn: "contains",
        accessorKey: "enabled",
        enableEditing: false,
        accessorFn: (row) => row.enabled ?? "-",
        Cell: ({ row }) => <Checkbox checked={row.original.enabled} disabled />,
        grow: true,
      },
      {
        header: t("aiConfigTable.name"),
        accessorKey: "name",
        sortingFn: "alphanumeric",
        filterFn: "contains",
      },
    ],
    [t]
  );
};
